
















































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import STextarea from '@/common/components/STextarea.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'UCIrvineChem1LD_FS3_Safety1',
  components: {FileUploadUiComponent, TableInput},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        rows: [
          {
            chemicalName: 'Chemical Name',
            GhsSymbol1: 'GHS Symbol #1',
            precautionaryStatement1: 'Associated Precautionary Statement',
            GhsSymbol2: 'GHS Symbol #2',
            precautionaryStatement2: 'Associated Precautionary Statement',
          },
          {
            chemicalName: '',
            GhsSymbol1: '',
            precautionaryStatement1: '',
            GhsSymbol2: '',
            precautionaryStatement2: '',
          },
        ],
        safetyMoment: '',
      },
      attachments: [] as File[],
      columns: [
        {label: 'Chemical Name', component: STextarea, prop: 'chemicalName', width: '30%'},
        {label: 'GHS Symbol #1', component: STextarea, prop: 'GhsSymbol1', width: '10%'},
        {
          label: 'Associated Precautionary Statement',
          component: STextarea,
          prop: 'precautionaryStatement1',
          width: '25%',
        },
        {label: 'GHS Symbol #2', component: STextarea, prop: 'GhsSymbol2', width: '10%'},
        {
          label: 'Associated Precautionary Statement',
          component: STextarea,
          prop: 'precautionaryStatement2',
          width: '25%',
        },
      ],
    };
  },
  methods: {},
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/GHS_Symbols.png');
    },
    attachments(): File[] {
      return [...this.attachments];
    },
  },
});
